import { render } from "./activateNumber.vue?vue&type=template&id=65503636"
import script from "./activateNumber.vue?vue&type=script&lang=js"
export * from "./activateNumber.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__